import { ProjectModel } from "./projectSlice";

export async function fetchProjects() {
    let data: ProjectModel[] = await (await fetch('/api/FetchProjects')).json();
    return data;
}